import { render, staticRenderFns } from "./SnippetVersionForm.vue?vue&type=template&id=074f72f7&"
import script from "./SnippetVersionForm.vue?vue&type=script&lang=ts&"
export * from "./SnippetVersionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports